module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "cmptDocPreparationForm",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-2 required-field",
    class: {
      'has-error': _vm.errors.first('data de proposta')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data de proposta",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.analise.proposal.dataProposta),
      callback: function($$v) {
        _vm.$set(_vm.analise.proposal, "dataProposta", $$v)
      },
      expression: "analise.proposal.dataProposta"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data de proposta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de proposta')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 required-field",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    },
    attrs: {
      "ng-class": "{'has-error': cmptProFormalizatinForm.$submitted && cmptProFormalizatinForm.analysisDate.$error.required }"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data da análise",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.analise.proposal.analysisDate),
      callback: function($$v) {
        _vm.$set(_vm.analise.proposal, "analysisDate", $$v)
      },
      expression: "analise.proposal.analysisDate"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data da análise')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data da análise')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 required-field",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    },
    attrs: {
      "ng-class": "{'has-error': cmptProFormalizatinForm.$submitted && cmptProFormalizatinForm.grantDate.$error.required }"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data de deferimento",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.analise.proposal.grantDate),
      callback: function($$v) {
        _vm.$set(_vm.analise.proposal, "grantDate", $$v)
      },
      expression: "analise.proposal.grantDate"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('introducao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('introducao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "name": "data de assinatura",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.analise.proposal.agreementAssignmentDate),
      callback: function($$v) {
        _vm.$set(_vm.analise.proposal, "agreementAssignmentDate", $$v)
      },
      expression: "analise.proposal.agreementAssignmentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "name": "data de emissao",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.analise.proposal.validityDate),
      callback: function($$v) {
        _vm.$set(_vm.analise.proposal, "validityDate", $$v)
      },
      expression: "analise.proposal.validityDate"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.analise.documentDraft,
      "documentTypes": _vm.requiredFormalizationDocumentsType,
      "documentosObrigatorios": _vm.documentosObrigatorios,
      "disable": true
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('actionApproval')
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approval.projectFormalizationResult),
      expression: "approval.projectFormalizationResult"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "APPROVED"
    },
    domProps: {
      "checked": _vm._q(_vm.approval.projectFormalizationResult, "APPROVED")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.approval, "projectFormalizationResult", "APPROVED")
      }
    }
  }), _vm._v("\n                      Aprovar o projeto\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approval.projectFormalizationResult),
      expression: "approval.projectFormalizationResult"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "DEVOLVIDO"
    },
    domProps: {
      "checked": _vm._q(_vm.approval.projectFormalizationResult, "DEVOLVIDO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.approval, "projectFormalizationResult", "DEVOLVIDO")
      }
    }
  }), _vm._v("\n                      Devolver para Formalização\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approval.projectFormalizationResult),
      expression: "approval.projectFormalizationResult"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "REJECTED",
      "id": "msgDef"
    },
    domProps: {
      "checked": _vm._q(_vm.approval.projectFormalizationResult, "REJECTED")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.approval, "projectFormalizationResult", "REJECTED")
      }
    }
  }), _vm._v("\n                      Retornar para análise\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approval.projectFormalizationResult),
      expression: "approval.projectFormalizationResult"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "actionApproval",
      "value": "CANCELED"
    },
    domProps: {
      "checked": _vm._q(_vm.approval.projectFormalizationResult, "CANCELED")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.approval, "projectFormalizationResult", "CANCELED")
      }
    }
  }), _vm._v("\n                      Cancelar o projeto\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('actionApproval')))]) : _vm._e()]), _vm._v(" "), (_vm.approval.projectFormalizationResult !== 'APPROVED' && 'projectFormalizationResult' in _vm.approval) ? _c('div', {
    staticClass: "form-group full required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justify"
    }
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approval.justify),
      expression: "approval.justify"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa"
    },
    domProps: {
      "value": (_vm.approval.justify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approval, "justify", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.approval.projectFormalizationResult) ? _c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onConclude
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Minuta / Plano de Trabalho")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Aprovação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "col",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px",
      "font-size": "12px"
    }
  }, [_vm._v("Decisões:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ea44492!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/aprovacaoProjeto.vue
// module id = 1904
// module chunks = 2